import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import * as stylex from '@stylexjs/stylex';
import { Dialog, DialogHeader } from '@astryxdesign/core/Dialog';
import { Layout, LayoutContent, LayoutFooter } from '@astryxdesign/core/Layout';
import { Button } from '@astryxdesign/core/Button';
import { HStack } from '@astryxdesign/core/HStack';
import { VStack } from '@astryxdesign/core/VStack';
import { Banner } from '@astryxdesign/core/Banner';
export interface DialogFormProps {
  title: string;
  onClose: () => void;
  onSubmit: () => void;
  submitting: boolean;
  valid: boolean;
  submitLabel?: string;
  error?: string | null;
  width?: number;
  children: ReactNode;
}
export function DialogForm({
  title,
  onClose,
  onSubmit,
  submitting,
  valid,
  submitLabel,
  error,
  width = 520,
  children
}: DialogFormProps) {
  const intl = useIntl();
  const close = (open: boolean) => {
    if (!open) onClose();
  };
  return <Dialog isOpen onOpenChange={close} purpose="form" width={width}>
      <form className="xjp7ctv" onSubmit={e => {
      e.preventDefault();
      if (valid && !submitting) onSubmit();
    }}>
        <Layout header={<DialogHeader title={title} onOpenChange={close} />} content={<LayoutContent>
              <VStack gap={4}>
                {error ? <Banner status="error" title={error} collapsible={false} /> : null}
                {children}
              </VStack>
            </LayoutContent>} footer={<LayoutFooter hasDivider>
              <HStack gap={2} hAlign="end" vAlign="center" wrap="wrap">
                <Button label={intl.formatMessage({
            id: 'common.cancel'
          })} variant="ghost" onClick={onClose} />
                <Button label={submitLabel ?? intl.formatMessage({
            id: 'common.save'
          })} variant="primary" type="submit" isDisabled={!valid} isLoading={submitting} />
              </HStack>
            </LayoutFooter>} />
      </form>
    </Dialog>;
}